export default {
    i18n: {
        "Group": "گروه",
        "Http": "HTTP",
        "handset": "دسته تلفن",
        "day": "روز",
        "auto": "خودکار",
        "bluetooth": "بلوتوث",
        "Device Information": "اطلاعات دستگاه",
        "Device Name": "نام دستگاه",
        "Volume": "Volume",
        "Access Denied.": "دسترسی رد شد.",
        "tamperAlarm": "آژیر هشدار دستکاری",
        "Card": "کارت",
        "Fingerprint": "اثر انگشت",
        "Date Time": "تاریخ زمان",
        "name": "نام",
        "minutes": "دقیقه‌ها",
        "timezone": "منطقه زمانی",
        "Are you sure you want to delete this device?": "آیا مطمئن هستید که می خواهید این دستگاه را حذف کنید؟",
        "Attendance Point Name": "نام نقطه حضور",
        "Mac": "مک",
        "Please try again 24 hours later.": "لطفاً 24 ساعت بعد دوباره **تلاش کنید.",
        "Action": "عمل",
        "unlock": "باز",
        "Address": "نشانی",
        "Owner": "صاحب",
        "Failed": "ناموفق",
        "Timeout": "مدت زمان طولانی",
        "Response": "واکنش",
        "caller": "تماس گیرنده",
        "receiver": "گیرنده",
        "doorLogs": "گزارش در",
        "callHistory": "تاریخچه تماس ها",
        "UID": "ید",
        "Call Type": "نوع تماس",
        "Code": "رمز",
        "User": "کاربر",
        "Device List": "لیست مانیتورهای من",
        "Model": "مدل",
        "Time": "زمان",
        "Company": "شرکت",
        "Property Managers": "مدیران املاک",
        "Current Version": "نسخه فعلی",
        "indoorMonitor": "مانیتور داخلی",
        "guardPhone": "گوشی",
        "close": "بستن",
        "Success": "موفقیت",
        "URL": "url",
        "Please select a device.": "لطفاً یک دستگاه را انتخاب کنید.",
        "Password is too weak.": "رمز عبور خیلی ضعیف است",
        "Company is required.": "شرکت مورد نیاز است.",
        "Your account is not activated, please contact your service provider.": "حساب شما فعال نشده است ، لطفاً با ارائه دهنده خدمات خود تماس بگیرید.",
        "Language": "زبان",
        "Face": "صورت",
        "Please set at least one access type.": "لطفاً حداقل یک نوع دسترسی را تنظیم کنید.",
        "Please contact your service provider to activate this advanced feature.": "لطفاً برای فعال کردن این ویژگی پیشرفته با ارائه دهنده خدمات خود تماس بگیرید.",
        "Community name": "نام جامعه",
        "Please enable PM App first.": "لطفاً ابتدا برنامه PM را فعال کنید.",
        "Username": "نام کاربری",
        "Change Log": "ورود به سیستم",
        "Assign": "اختصاص دادن",
        "Floor": "طبقه",
        "Link Device": "دستگاه پیوند",
        "Accessible Floors": "طبقه های قابل دسترسی",
        "Upgrade": "بالا بردن",
        "Function": "تابع",
        "callDuration": "مدت فراخوانی",
        "No": "هیچ",
        "Verification Code": "کد تایید",
        "Expiration Time": "زمان انقضا",
        "PIN": "پین",
        "MAC": "مک",
        "Building": "ساختمان",
        "APT": "اتاق",
        "ID": "کارت شناسایی",
        "Name": "نام",
        "activities": "فعالیت ها",
        "Obtain": "به دست آوردن",
        "call": "زنگ زدن",
        "Group Call": "تماس گروهی",
        "Delete": "حذف",
        "Yes": "آره",
        "Door Release PIN": "پین رها کردن درب",
        "Email": "پست الکترونیک",
        "Mobile Number doesn\'t exist.": "شماره تلفن همراه وجود ندارد.",
        "Tips": "نکات",
        "Password": "پسورد",
        "The end time cannot be earlier than the start time.": "زمان پایان نمی تواند زودتر از زمان شروع باشد.",
        "Back": "عقب",
        "File format error.": "خطای قالب پرونده",
        "motionDetection": "تشخیص حرکت",
        "You are trying too often, please try again in 5 minutes": "شما بیش از حد سعی می کنید ، لطفاً 5 دقیقه دوباره امتحان کنید",
        "User name too long.": "نام کاربر خیلی طولانی است.",
        "This MAC address is redirected on RPS.": "این آدرس MAC در RPS هدایت می شود.",
        "No Answer": "بدون پاسخ",
        "failedToUnlock": "باز کردن قفل ناموفق بود",
        "visitor": "بازدید کننده",
        "yesterday": "دیروز",
        "Too large data! Please first export the data before %s first,thanks.": "داده های خیلی بزرگ!",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "لطفاً بررسی کنید که آیا سفارشات پرداخت نشده وجود دارد ، در غیر این صورت ، لطفاً با ارائه دهنده خدمات خود تماس بگیرید",
        "lock": "بستن در",
        "open": "باز کن",
        "The PersonalAccount is not active.": "PersonalAccount فعال نیست.",
        "You cannot link an account that already link other accounts.": "شما نمی توانید حسابی را که قبلاً سایر حساب ها را پیوند می دهد پیوند دهید.",
        "You cannot link multiple property manager accounts under the same installer account.": "شما نمی توانید چندین حساب مدیر املاک را تحت همان حساب نصب کننده پیوند دهید.",
        "You cannot link to the currently logged in account.": "شما نمی توانید به حساب وارد شده در حال حاضر وارد شوید.",
        "confirmToDeleteIt?": "تأیید آن را تأیید کنید؟",
        "captureLogs": "گزارش تصاویر",
        "Doors": "دره",
        "All Doors": "همه درها",
        "Lock List": "لیست قفل",
        "Link Device Relay": "رله دستگاه پیوند",
        "Added Successfully!": "با موفقیت اضافه شد!",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "هنگامی که قفل با یک رله در ارتباط است ، هنگام ایجاد رله قفل قفل قفل می شود.",
        "Adding...": "اضافه كردن...",
        "nfc": "NFC",
        "Delete Device": "حذف دستگاه",
        "date": "تاریخ",
        "Device deleted successfully": "دستگاه با موفقیت حذف شد",
        "Failed to delete device": "حذف دستگاه انجام نشد",
        "Are you sure you want to cancel?": "آیا مطمئنید می‌خواهید لغو کنید؟",
        "Unlimited": "نامحدود",
        "Battery Level": "سطح باتری",
        "Password Incorrect.": "رمز عبور نادرست است.",
        "deliverySystemVerification": "تأیید سیستم تحویل",
        "None": "هیچکدام",
        "Upgrading...": "در حال ارتقا...",
        "amenityReservation": "رزرو امکانات",
        "idAccess": " ID دسترسی",
        "RF Card": "کارت RF",
        "exitButton": "دکمه خروج",
        "Please select at least one item.": "لطفاً حداقل یک مورد را انتخاب کنید.",
        "The ID can contain only digits and letters, up to 32 characters.": "شناسه فقط می‌تواند شامل اعداد و حروف باشد و حداکثر تا ۳۲ کاراکتر باشد.",
        "The PIN is not available.": "رمز عبور در دسترس نیست.",
        "Change WiFi": "تغییر وای‌فای",
        "Phone number": "شماره تلفن",
        "Invalid {0}.": "نامعتبر {0}.",
        "{0} already exists.": "{0} قبلاً وجود دارد.",
        "Operation failed!": "عملیات ناموفق بود!",
        "Failed to get data.": "دریافت داده‌ها ناموفق بود.",
        "You do not have the necessary permissions to perform this operation.": "شما مجوزهای لازم برای انجام این عملیات را ندارید.",
        "You can only import one template at a time in the current site.": "در سایت فعلی، شما فقط می‌توانید یک قالب را در هر بار وارد کنید.",
        "Delivery name": "نام تحویل‌گیرنده",
        "MAC address not in the MAC library.": "آدرس MAC در کتابخانه MAC وجود ندارد.",
        "Please delete devices under this building.": "لطفاً دستگاه‌های زیر این ساختمان را حذف کنید.",
        "The start time cannot be later than the end time.": "زمان شروع نمی‌تواند دیرتر از زمان پایان باشد.",
        "emergency action type": "نوع اقدام اضطراری",
        "Only 1000 data items can be imported at a time.": "در هر بار فقط می‌توان حداکثر ۱۰۰۰ داده وارد کرد.",
        "The password is too short.": "رمز عبور خیلی کوتاه است.",
        "The data has been updated. Please refresh the page and try again.": "داده‌ها به‌روزرسانی شده‌اند. لطفاً صفحه را تازه کنید و دوباره تلاش کنید.",
        "AutoP length must be less 2048 bytes.": "طول AutoP باید کمتر از ۲۰۴۸ بایت باشد.",
        "File Check Failed": "بررسی فایل ناموفق بود",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "ورود به حساب مدیر منقضی شده است، لطفاً با ارائه‌دهنده خدمات تماس بگیرید.",
        "iqPinVerificationFailed": "تأیید PIN IQ ناموفق بود.",
        "accountBlacklisted": "حساب کاربری در لیست سیاه قرار گرفت.",
        "outsideAuthorizedTime": "خارج از زمان مجاز.",
        "network group": "گروه شبکه",
        "Company name": "نام شرکت",
        "Group name": "نام گروه",
        "relay": "رله",
        "motionTime": "زمان تشخیص حرکت",
        "motionType": "نوع تشخیص حرکت",
        "postalCode": "کد پستی",
        "floor format": "فرمت طبقه",
        "mobilePhone": "شماره موبایل",
        "time format": "فرمت زمان",
        "security relay": "رله ایمنی",
        "Param": "پارام",
        "Offline Code": "کد آفلاین",
        "Add akubela Smart Locks": "افزودن قفل هوشمند akubela",
        "Module Version": "نسخه ماژول",
        "Lock Body Version": "نسخه بدنه قفل",
        "Available Version": "نسخه موجود",
        "Please wake up the lock screen and then upgrade.": "لطفاً صفحه قفل را بیدار کنید و سپس ارتقا دهید.",
        "This process will take some time, please be patient.": "این فرایند کمی زمان می‌برد، لطفاً شکیبا باشید.",
        "Please confirm that the WiFi network is functioning properly.": "لطفاً اطمینان حاصل کنید که شبکه وای‌فای به درستی کار می‌کند.",
        "Please wake up the lock screen.": "لطفاً صفحه قفل را بیدار کنید.",
        "This lock has already been added to another apartment.": "این قفل قبلاً به یک آپارتمان دیگر اضافه شده است.",
        "This lock has already been added to the apartment.": "این قفل قبلاً به آپارتمان اضافه شده است.",
        "Pin Code": "کد پین",
        "Too many failed attempts, please try again in a few minutes.": "تعداد تلاش‌های ناموفق زیاد بود، لطفاً چند دقیقه دیگر دوباره امتحان کنید.",
        "Login Account": "ورود به حساب",
        "Same account cannot login in different ins.": "یک حساب کاربری نمی‌تواند در نصاب‌های مختلف وارد شود.",
        "Lock Name": "نام قفل",
        "Smart Locks": "قفل‌های هوشمند",
        "Add Smart Lock": "افزودن قفل هوشمند",
        "The selected duration cannot be more than one year.": "مدت زمان انتخاب‌شده نمی‌تواند بیش از یک سال باشد.",
        "The end time of the break time cannot be later than the end work time.": "زمان پایان استراحت نمی‌تواند دیرتر از زمان پایان کار باشد.",
        "The start time of the break time cannot be earlier than the start work time.": "زمان شروع زمان استراحت نمی‌تواند زودتر از زمان شروع کار باشد.",
        "The end time of the valid check time cannot be earlier than the end work time.": "زمان پایان اعتبار چک نمی‌تواند زودتر از زمان پایان کار باشد.",
        "The start time of the valid check time cannot be later than the start work time.": "زمان شروع اعتبار بررسی نمی‌تواند دیرتر از زمان شروع کار باشد.",
        "Deleting failed. The timetable is used by a shift.": "حذف انجام نشد. جدول زمانی توسط یک شیفت استفاده می‌شود.",
        "Deleting failed. The shift is in use.": "حذف انجام نشد. شیفت در حال استفاده است.",
        "Deleting failed. The leave type is in use.": "حذف انجام نشد. نوع مرخصی در حال استفاده است.",
        "Valid time conflicts with an existing schedule.": "زمان معتبر با برنامه‌ریزی موجود تداخل دارد.",
        "The timing for multiple schedules must not coincide.": "زمان‌بندی چندین برنامه نباید با یکدیگر همزمان باشد.",
        "Attendance Log": "گزارش حضور",
        "Added Failed!": "افزودن ناموفق بود!",
        "Setting WiFi": "در حال تنظیم وای‌فای",
        "License Plate": "پلاک خودرو",
        "key": "کلمه عبور",
        "IQ Offline.": "آی‌کیو آفلاین.",
        "{0}Unlock": "باز کردن {0}",
        "automatically": "خودکار",
        "manually": "دستی",
        "Video Storage": "ذخیره‌سازی ویدیو",
        "Device(s) for Video Storage": "دستگاه(ها) برای ذخیره ویدیو",
        "The amount of exported data is too large. Please export it in batches.": "حجم داده‌های صادرشده بسیار زیاد است. لطفاً داده‌ها را به صورت دسته‌ای صادر کنید.",
        "Auto-record video when door unlocks": "ضبط خودکار ویدیو هنگام باز شدن در",
        "Auto-record video during calls": "ضبط خودکار ویدیو هنگام تماس",
        "Manual video recording in monitoring": "ضبط دستی ویدیو در پایش",
        "Saved for 30days/60days/90days": "ذخیره برای ۳۰ روز/۶۰ روز/۹۰ روز",
        "To subscribe, please contact your provider for activation.": "برای اشتراک، لطفاً با ارائه‌دهنده سرویس خود جهت فعال‌سازی تماس بگیرید.",
        "Saved for {0}days": "ذخیره شده برای {0} روز",
        "Subscribed Plan": "طرح اشتراک",
        "Supported Devices: {0}": "دستگاه‌های پشتیبانی شده: {0}",
        "{0}Lock": "قفل کردن {0}",
        "Video Saving": "ذخیره‌سازی ویدیو",
        "Download Completed!": "دانلود تکمیل شد!",
        "Fail to download.": "دانلود ناموفق بود.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "حذف انجام نشد! مدیر ملک به یک حساب RentManager متصل شده است، ابتدا باید آن را حذف کنید.",
        "No log to be exported.": "هیچ گزارشی برای صادر کردن وجود ندارد.",
        "capture&Video": "عکس و ویدیو",
        "packageDetection": "شناسایی بسته",
        "Time format is invalid.": "فرمت زمان نامعتبر است.",
        "No permission to export logs of this type.": "اجازه‌ای برای صادر کردن گزارش‌های این نوع وجود ندارد.",
        "Project type is invalid.": "نوع پروژه نامعتبر است.",
        "Salto Account Blocked.": "حساب سالتو مسدود شده است.",
        "Remote open not in access group.": "باز کردن از راه دور در گروه دسترسی نیست.",
        "SIP Account required.": "وارد کردن حساب SIP الزامی است.",
        "The PIN must be {0} digits.": "پین باید {0} رقم باشد.",
        "gatewayConnectionUnavailable": "اتصال به دروازه ممکن نیست.",
        "Invalid Username or Password": "نام کاربری یا رمز عبور نامعتبر است",
        "Account already linked to another user.": "این حساب قبلاً به کاربر دیگری متصل شده است.",
        "The account has been added by another user.": "این حساب توسط کاربر دیگری اضافه شده است.",
        "Failed to add. This user already has 5 license plates.": "افزودن ناموفق بود. این کاربر قبلاً ۵ پلاک خودرو دارد.",
        "Please at least select a door.": "لطفاً حداقل یک در انتخاب کنید.",
        "UHF Card": "کارت UHF",
        "personnel": "پرسنل",
        "Parking Lot Name": "نام پارکینگ",
        "Controlled Relay": "رله کنترل‌شده",
        "No Permission": "دسترسی وجود ندارد",
        "Please ensure that all doors in the project are activated at the same time.": "لطفاً اطمینان حاصل کنید که تمام درهای پروژه به طور همزمان فعال شوند.",
        "gatewayBusy": "دروازه مشغول است",
        "Please set the perimeter door group first.": "لطفاً ابتدا گروه درهای محیطی را تنظیم کنید.",
        "Please ensure that all doors in the project are renewed at the same time.": "لطفاً اطمینان حاصل کنید که همه درهای پروژه به طور همزمان تمدید شوند.",
        "When lockdown is on, the controlled relay cannot be modified.": "هنگامی که قفل فعال است، رله کنترل‌شده قابل تغییر نیست.",
        "DetectionLogs": "گزارش‌های شناسایی",
        "packageIn": "ورود بسته",
        "packageOut": "خروج بسته",
        "View Progress": "مشاهده پیشرفت",
        "Check if the WiFi is operating on the 2.4GHz band.": "بررسی کنید که آیا وای‌فای در باند 2.4 گیگاهرتز کار می‌کند.",
        "Verify that the WiFi password is correct.": "اطمینان حاصل کنید که رمز عبور وای‌فای صحیح است.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "در طول پیکربندی هات‌اسپات مطمئن شوید که به هات‌اسپات دستگاه صحیح متصل هستید.",
        "Offline Code Unlock": "باز کردن با کد آفلاین",
        "Salto Token Expired.": "توکن سالتو منقضی شده است.",
        "Lock Offline": "قفل آفلاین",
        "identity information! Please login again": "اطلاعات هویت! لطفاً دوباره وارد شوید",
        "Email is required.": "وارد کردن ایمیل الزامی است.",
        "Mobile number is required.": "وارد کردن شماره موبایل الزامی است.",
        "You can\'t make payments for offices in different time zones.": "شما نمی‌توانید برای دفاتر در مناطق زمانی مختلف پرداخت انجام دهید.",
        "The current scheduling staff exceeds 200 people.": "تعداد کارکنان برنامه‌ریزی فعلی از ۲۰۰ نفر فراتر رفته است.",
        "param": "پارام",
        "Invalid UserName or Password": "نام کاربری یا رمز عبور نامعتبر است",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "حساب Salto KS شما اجازه تغییر نام قفل را ندارد.",
        "Owner is required.": "مالک مورد نیاز است.",
        "Office is required.": "دفتر مورد نیاز است.",
        "PIN or RF Card is required.": "وارد کردن رمز عبور یا کارت RF الزامی است.",
        "RF card": "کارت RF",
        "Personnel is required.": "نیروی انسانی مورد نیاز است.",
        "email address": "آدرس ایمیل",
        "mobile number": "شماره موبایل",
        "The length must be less than 32 characters.": "طول باید کمتر از ۳۲ کاراکتر باشد.",
        "The length must be less than 256 characters.": "طول باید کمتر از ۲۵۶ کاراکتر باشد.",
        "Access Group is required.": "گروه دسترسی مورد نیاز است.",
        "Device is required.": "دستگاه مورد نیاز است.",
        "Admin is required.": "مدیر لازم است.",
        "Mobile number": "شماره موبایل",
        "schedules": "برنامه‌ها",
        "Timetable name": "نام جدول زمانی",
        "Shift name": "نام شیفت",
        "Leave type": "نوع مرخصی",
        "recheck in time": "زمان دوباره ورود",
        "recheck out time": "زمان جدید خروج را بررسی کنید",
        "The building name": "نام ساختمان",
        "Building is required.": "ساختمان مورد نیاز است.",
        "selection, The same reader cannot be set for both entry and exit": "انتخاب، نمی‌توان همان دستگاه کارت‌خوان را برای ورود و خروج تنظیم کرد",
        "Door number": "شماره در",
        "door input cannot be selection duplicated.": "ورودی در نمی‌تواند به طور تکراری انتخاب شود.",
        "Group is required.": "گروه مورد نیاز است.",
        "Title can contain up to 32 characters.": "عنوان می‌تواند تا ۳۲ نویسه داشته باشد.",
        "Content can contain up to 1024 characters.": "محتوا می‌تواند تا ۱۰۲۴ نویسه را شامل شود.",
        "Content can contain up to 64 characters.": "محتوا می‌تواند حداکثر ۶۴ نویسه داشته باشد.",
        "Report is required.": "ارائه گزارش الزامی است.",
        "ID is required.": "ارائه کارت شناسایی الزامی است.",
        "The office does not exist.": "دفتر وجود ندارد.",
        "Office name": "نام دفتر",
        "The Temp Key does not exist.": "کلید موقت وجود ندارد.",
        "autolock time": "زمان قفل خودکار",
        "The User does not exist.": "کاربر وجود ندارد.",
        "The Installer does not exist.": "نصاب وجود ندارد.",
        "The Project does not exist.": "پروژه وجود ندارد.",
        "The Distributor does not exist.": "توزیع‌کننده وجود ندارد.",
        "The Community Device does not exist.": "دستگاه جامعه وجود ندارد.",
        "The Property Manager does not exist.": "مدیر املاک وجود ندارد.",
        "The Sub Distributor does not exist.": "زیرموزع وجود ندارد.",
        "The Single Slave does not exist.": "برده‌ی تنها وجود ندارد.",
        "The Property Manager EndUser does not exist.": "کاربر نهایی مدیر ملک وجود ندارد.",
        "The Family Member does not exist.": "عضو خانواده وجود ندارد.",
        "Set Failed!": "تنظیم انجام نشد!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "شما به حد مجاز ۱۰ درخواست کد دسترسی در مدت ۳۰ دقیقه رسیده‌اید. لطفاً بعداً دوباره تلاش کنید.",
        "This Email doesn\'t exist.": "این ایمیل وجود ندارد.",
        "detection type": "نوع شناسایی",
        "Device UUID": "شناسه UUID دستگاه",
        "smart lock device": "دستگاه قفل هوشمند",
        "You are trying too often, please try again in 5 minutes.": "شما بیش از حد تلاش کرده‌اید، لطفاً ۵ دقیقه دیگر دوباره امتحان کنید.",
        "You can only import one file at a time. Please wait for the current import to finish.": "شما فقط می‌توانید یک فایل را همزمان وارد کنید. لطفاً منتظر بمانید تا واردسازی فعلی به پایان برسد.",
        "NVR Name": "نام NVR",
        "NVR Address": "آدرس NVR",
        "Stay Alarm": "هشدار توقف طولانی",
        "Happended On": "رخ داده در",
        "Edit Milesight NVR": "ویرایش Milesight NVR",
        "Add Milesight NVR": "افزودن Milesight NVR",
        "Auto-record video on motion detection, package detection": "ضبط خودکار ویدیو هنگام شناسایی حرکت یا بسته",
        "A 7-day free trial is included with your subscription.": "اشتراک شما شامل ۷ روز استفاده رایگان است.",
        "For service renewal, please reach out to your provider.": "برای تمدید سرویس، با ارائه‌دهنده خود تماس بگیرید.",
        "Allow the Property Manager to view recorded videos": "به مدیر ساختمان اجازه دهید ویدیوهای ضبط شده را مشاهده کند",
        "Please ensure the WiFi network is working properly.": "لطفاً مطمئن شوید شبکه وای‌فای به درستی کار می‌کند.",
        "Edit akubela Smart Locks": "ویرایش قفل هوشمند akubela",
        "Upgraded Successfully!": "با موفقیت ارتقا یافت!",
        "Upgraded Failed!": "ارتقا ناموفق بود!",
        "Editing...": "در حال ویرایش...",
        "Edited successfully!": "با موفقیت ویرایش شد!",
        "Edited Failed!": "ویرایش ناموفق بود!",
        "Downloading video...": "در حال دانلود ویدیو...",
        "All Locks": "همه قفل‌ها",
        "Select Locks": "انتخاب قفل‌ها",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "پین {0} رقمی زمانی که قفل هوشمند akubela به شبکه متصل شود قابل استفاده است. لطفاً توجه کنید ممکن است مدتی طول بکشد تا پین پس از همگام‌سازی فعال شود.",
        "Please at least select a door or a lock.": "لطفاً حداقل یک در یا یک قفل انتخاب کنید.",
        "This lock has already been added to your apartment.": "این قفل قبلاً به واحد شما اضافه شده است.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "این قفل قبلاً به واحد دیگری اضافه شده است. لطفاً با ارائه‌دهنده خدمات خود تماس بگیرید.",
        "LockBody Version": "نسخه بدنه قفل",
        "Two-factor Authentication": "احراز هویت دو مرحله‌ای",
        "Monitoring Scope": "دامنه نظارت",
        "Stay Duration": "مدت زمان توقف",
        "Volume Settings": "تنظیمات صدا",
        "get card list for lock error": "خطا در دریافت فهرست کارت برای قفل",
        "get card list parse fail": "شکست در تجزیه فهرست کارت‌ها",
        "get pin list for lock error": "خطا در دریافت فهرست پین برای قفل",
        "get pin list parse fail": "شکست در تجزیه فهرست کلیدها",
        "fingerprint code must be less than 2048 characters or empty.": "کد اثر انگشت باید کمتر از ۲۰۴۸ نویسه باشد یا خالی باشد.",
        "Personnel not in office.": "پرسنل در دفتر حضور ندارند.",
        "customize form fail.": "سفارشی‌سازی فرم با شکست مواجه شد.",
        "smart lock type error.": "خطا در نوع قفل هوشمند.",
        "invalid client id or secret": "شناسه یا رمز کاربری نامعتبر است",
        "invalid account or password": "حساب کاربری یا رمز عبور نامعتبر است",
        "invalid access token": "توکن دسترسی نامعتبر است",
        "invalid refresh token": "توکن تازه‌سازی نامعتبر است",
        "no permission to access this project": "شما اجازه دسترسی به این پروژه را ندارید",
        "Stay Alarm Time": "زمان باقی ماندن زنگ هشدار",
        "This function only support sl20 lock.": "این قابلیت تنها از قفل sl20 پشتیبانی می‌کند.",
        "Json marshal error.": "خطای سرهم‌بندی Json.",
        "Json unmarshal error.": "خطای جداسازی Json.",
        "Illegal request, not added within valid time.": "درخواست غیرمجاز، در زمان معتبر اضافه نشده است.",
        "invalid nvr type": "نوع nvr نامعتبر است",
        "project is empty": "پروژه خالی است",
        "project type is invalid": "نوع پروژه نامعتبر است",
        "owner is invalid": "مالک نامعتبر است",
        "url is invalid": "آدرس اینترنتی نامعتبر است",
        "password is invalid": "رمز عبور نامعتبر است",
        "building is invalid": "ساختمان نامعتبر است",
        "fail to get data": "دریافت داده ناموفق بود",
        "invalid allow pm view type": "نوع مجاز نمای pm نامعتبر است",
        "Data not exist.": "داده وجود ندارد.",
        "cannot find community PrivateKey.": "کلید خصوصی انجمن یافت نشد.",
        "cannot find single PrivateKey.": "کلید خصوصی تکی یافت نشد.",
        "The third party not exist.": "شخص ثالث وجود ندارد.",
        "{0} and indoor monitors/guard phones": "{0} و مانیتورهای داخلی/تلفن‌های نگهبان",
        "{0} and indoor monitors/guard phones, with phone as backup": "{0} و مانیتورهای داخلی/تلفن‌های نگهبان، سپس تماس با تلفن در صورت عدم پاسخ‌گویی",
        "Indoor monitors/guard phones with {0} as backup": "مانیتورهای داخلی/تلفن‌های نگهبان، سپس {0} در صورت عدم پاسخ‌گویی",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "مانیتورهای داخلی/تلفن‌های نگهبان، سپس {0} و در نهایت تماس با تلفن",
        "{0} Intercom Feature": "ویژگی اینترکام {0}",
        "Capture on {0}": "ثبت تصویر در {0}",
        "{0} Intercom Feature is not activated or has expired.": "ویژگی آیفون {0} فعال نیست یا منقضی شده است.",
        "fingerprint code must be equal 1620 characters or empty.": "کد اثر انگشت باید دقیقاً ۱۶۲۰ نویسه باشد یا خالی باشد.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "برای اطمینان از موفقیت ارتقا، لطفاً قبل از ادامه سطح باتری قفل را بالای ۴۰٪ قرار دهید.",
        "Automatic Locking Time": "زمان قفل خودکار",
        "WiFi Keep-Alive": "نگهداری وای‌فای فعال",
        "WiFi Setting": "تنظیمات وای‌فای",
        "Connecting the network...": "در حال اتصال به شبکه...",
        "Set successfully!": "با موفقیت تنظیم شد!",
        "The offline code can be used even if the lock is not connected to WiFi.": "کد آفلاین حتی بدون اتصال وای‌فای نیز قابل استفاده است.",
        "Enabling this feature will increase the lock\'s power consumption.": "فعال‌سازی این ویژگی باعث افزایش مصرف باتری قفل می‌شود.",
        "Each offline code can only be used once.": "هر کد آفلاین فقط یک‌بار قابل استفاده است.",
        "Receiver Info": "اطلاعات گیرنده",
        "log id": "شناسه ورود",
        "Create HW SN Config Empty SN.": "ایجاد پیکربندی SN هواوی با SN خالی.",
        "The SN": "شماره سریال",
        "SN can contain up to 32 characters.": "SN می‌تواند حداکثر ۳۲ کاراکتر داشته باشد.",
        "Check HW SN Not Found.": "SN هواوی یافت نشد.",
        "the end user not found": "کاربر نهایی یافت نشد",
        "Family Call": "تماس خانوادگی",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "در طول ارتقا، تمام قابلیت‌های مرتبط با قفل به طور موقت غیرفعال خواهند بود.",
        "8-digit PIN code starting with \"9\" is invalid!": "کد پین ۸ رقمی که با «9» شروع شود نامعتبر است!",
        "Lock name length must be between 1 and 50": "طول نام قفل باید بین ۱ تا ۵۰ باشد",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "تعداد پرسنلی که از سرویس تلفن ثابت استفاده می‌کنند نباید از تعداد افرادی که از سرویس اینترکام {0} استفاده می‌کنند بیشتر باشد.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "تعداد مدیرانی که دارای سرویس تلفن ثابت هستند نباید از تعداد مدیرانی که دارای سرویس اینترکام {0} هستند بیشتر باشد.",
        "charge type": "نوع هزینه",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "تعداد پرسنلی که از سرویس خط ثابت استفاده می‌کنند نباید از تعداد افرادی که از اینترکام SmartPlus استفاده می‌کنند بیشتر باشد.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "تعداد مدیرانی که از سرویس خط ثابت استفاده می‌کنند نباید از تعداد مدیرانی که از اینترکام SmartPlus استفاده می‌کنند بیشتر باشد.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "یک کارت‌خوان نمی‌تواند همزمان برای ویگند و RS485 تنظیم شود.",
        "parameter error": "خطای پارامتر",
        "community name already exist": "نام انجمن از قبل وجود دارد",
        "personnel app without intercom feature number": "برنامه پرسنلی بدون شماره ویژگی اینترکام",
        "check feature billing charge plan new error": "خطا در بررسی طرح جدید صورتحساب ویژگی",
        "subscription not found": "اشتراک پیدا نشد",
        "System setting record not found.": "رکورد تنظیمات سیستم یافت نشد.",
        "Smart home not enabled.": "خانه هوشمند فعال نشده است.",
        "the apt call type value is invalid.": "مقدار نوع تماس apt نامعتبر است.",
        "the ip call or sip call value is invalid.": "مقدار تماس IP یا تماس SIP نامعتبر است.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "پین‌کد باید عددی بین ۲ تا ۸ رقم باشد، اما نمی‌تواند یک عدد ۸ رقمی که با ۹ شروع شود یا خالی باشد.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "کارت rf باید A-F0-9 باشد و کمتر از ۱۶ رقم یا خالی باشد.",
        "owner cannot be empty.": "مالک نمی‌تواند خالی باشد.",
        "creator cannot be empty.": "ایجادکننده نمی‌تواند خالی باشد.",
        "the creator type value is invalid": "مقدار نوع ایجادکننده نامعتبر است",
        "the IsCreateByPm value is invalid": "مقدار IsCreateByPm نامعتبر است",
        "the pinCode already exist": "پین‌کد از قبل وجود دارد",
        "the rfCard already exist": "کارت rf قبلاً وجود دارد",
        "license plate is invalid.": "شماره پلاک نامعتبر است.",
        "owner info is invalid.": "اطلاعات مالک نامعتبر است.",
        "uhf is invalid.": "UHF نامعتبر است.",
        "time control is invalid.": "کنترل زمان نامعتبر است.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "به محدودیت ۵ پلاک خودرو رسیده‌اید و اجازه افزودن ندارید",
        "the plate already exist": "پلاک قبلاً وجود دارد",
        "the uhf already exist": "UHF قبلاً وجود دارد",
        "empty community": "انجمن خالی",
        "no find license Plate": "پلاک پیدا نشد",
        "IDAccess mode must be 0, 1, or 2.": "حالت دسترسی باید ۰، ۱ یا ۲ باشد.",
        "Run field is required when mode is 1 or 2.": "هنگام انتخاب حالت ۱ یا ۲، فیلد Run الزامی است.",
        "Serial field is required when mode is 2.": "هنگام انتخاب حالت ۲، فیلد سریال الزامی است.",
        "the pin cannot be empty": "پین نمی‌تواند خالی باشد",
        "the rfCard cannot be empty": "کارت rf نمی‌تواند خالی باشد",
        "the IDAccess already exist": "دسترسی ID قبلاً وجود دارد",
        "the resident cannot be empty": "ساکن نمی‌تواند خالی باشد",
        "the fingerprint cannot be empty": "اثر انگشت نمی‌تواند خالی باشد",
        "the face cannot be empty": "چهره نمی‌تواند خالی باشد",
        "not found pin": "پین پیدا نشد",
        "not found rfCard": "کارت rf پیدا نشد",
        "not found IDAccess": "دسترسی ID پیدا نشد",
        "not found fingerprint": "اثر انگشت پیدا نشد",
        "not found face": "چهره پیدا نشد",
        "face pic is invalid.": "عکس چهره نامعتبر است.",
        "community build and room cannot be empty.": "ساختار انجمن و اتاق نمی‌تواند خالی باشد.",
        "device info mac cannot be empty.": "اطلاعات MAC دستگاه نمی‌تواند خالی باشد.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "نوع زمان‌بندی باید ۰، ۱، ۲ باشد یا فرمت زمان نامعتبر است یا dataflag خارج از ۰-۱۲۷ است.",
        "MAC address cannot be empty.": "آدرس MAC نمی‌تواند خالی باشد.",
        "MAC address 0C1105000000 is not allowed.": "آدرس MAC 0C1105000000 مجاز نیست.",
        "MAC address must be 12 hexadecimal characters.": "آدرس MAC باید ۱۲ رقم هگزادسیمال باشد.",
        "Scheduler type value is invalid.": "مقدار نوع زمان‌بندی نامعتبر است.",
        "parse is fail": "تجزیه شکست خورد",
        "the fingerprint already exist": "اثر انگشت قبلاً وجود دارد",
        "the licensePlate cannot be empty": "پلاک خودرو نمی‌تواند خالی باشد",
        "the licensePlate already exist": "پلاک خودرو قبلاً وجود دارد",
        "idaccess run must be 10 digit number or end with -K.": "اجرا idaccess باید عدد ۱۰ رقمی باشد یا با -K پایان یابد.",
        "idaccess serial must be 9 digit number.": "سریال idaccess باید ۹ رقمی باشد.",
        "relay not in 0-15": "رله خارج از بازه ۰ تا ۱۵ است",
        "security relay not in 0-3": "رله امنیتی خارج از بازه ۰ تا ۳ است",
        "file name is wrong": "نام فایل اشتباه است",
        "access mode specified": "حالت دسترسی تعیین شد",
        "create community user accessmode failed.": "ایجاد حالت دسترسی کاربر انجمن ناموفق بود.",
        "delete community user accessmode failed.": "حذف حالت دسترسی کاربر انجمن ناموفق بود.",
        "Cannot delete building because it has associated users.": "نمی‌توان ساختمان را حذف کرد چون کاربران وابسته دارد.",
        "Cannot delete building because it has associated Salto devices.": "امکان حذف ساختمان وجود ندارد زیرا با دستگاه‌های سالتو مرتبط است.",
        "community building not found": "ساختمان انجمن پیدا نشد",
        "Invalid Name Display": "نمایش نام نامعتبر",
        "The Community does not exist.": "انجمن وجود ندارد.",
        "Update CommunityIsInstallerKit Error.": "خطا در به‌روزرسانی CommunityIsInstallerKit.",
        "Dis Not SupportCommunityCalls Error.": "نمایندگی از تماس‌های انجمن پشتیبانی نمی‌کند.",
        "Community Has Special Device, Not Allowed To Delete.": "انجمن دستگاه خاص دارد، حذف مجاز نیست.",
        "The project smart home switch must be disabled": "سوییچ خانه هوشمند پروژه باید غیرفعال باشد",
        "There are ITec Locks in project": "قفل‌های ITec در پروژه وجود دارند",
        "There are Salto Locks in project": "قفل‌های Salto در پروژه وجود دارند",
        "There are Dormakaba Locks in project": "قفل‌های Dormakaba در پروژه وجود دارند",
        "It is rent manager project": "این پروژه rent manager است",
        "It is installer account": "این حساب نصاب است",
        "contact preference type": "نوع ترجیح تماس",
        "Floor list is required when not all floors.": "وقتی همه طبقات انتخاب نشده‌اند، فهرست طبقات لازم است.",
        "Building floors list is required when all buildings.": "در صورت انتخاب تمام ساختمان‌ها، لیست طبقات ساختمان ضروری است.",
        "Indoor monitor name is required.": "نام مانیتور داخلی الزامی است.",
        "The primary account is not activated.": "حساب اصلی فعال نشده است.",
        "You can\'t create more family member accounts.": "نمی‌توانید حساب عضوی خانواده بیشتری ایجاد کنید.",
        "community user not found": "کاربر انجمن پیدا نشد",
        "community is empty": "انجمن خالی است",
        "the end user not master user": "کاربر نهایی کاربر اصلی نیست",
        "the end user not member user": "کاربر نهایی کاربر وابسته نیست",
        "The email already exists and cannot be repeated": "این ایمیل قبلاً وجود دارد و تکرار نمی‌شود",
        "The mobile Number already exists": "شماره موبایل قبلاً وجود دارد",
        "The room number format error.": "فرمت شماره اتاق اشتباه است.",
        "community not found": "انجمن پیدا نشد",
        "resident not found": "ساکن پیدا نشد",
        "installer not found": "نصاب پیدا نشد",
        "Operation Failed!": "عملیات ناموفق بود!",
        "You don\'t have operate permission": "شما مجوز انجام عملیات را ندارید",
        "You cannot select Relay and Door at the same time": "نمی‌توانید همزمان رله و در را انتخاب کنید",
        "user don\'t active": "کاربر فعال نیست",
        "User has expired": "کاربر منقضی شده است",
        "timestamp must be within 3 minutes of current server time": "مهر زمان باید در ۳ دقیقه زمان فعلی سرور باشد",
        "cannot find single rf Card.": "کارت rf تکی پیدا نشد.",
        "cannot find community rf Card.": "کارت rf متعلق به انجمن پیدا نشد.",
        "smartLock model": "مدل قفل هوشمند",
        "the project does not open smart home": "این پروژه خانه هوشمند را فعال نکرده است",
        "php web server error": "خطای سرور وب php",
        "Ins not found.": "Ins پیدا نشد.",
        "RentManage Unit Not Set.": "واحد RentManage تنظیم نشده است.",
        "add audit log error": "خطا در افزودن لاگ حسابرسی",
        "check building in error": "خطا در بررسی ساختمان",
        "Special devices cannot be deleted": "امکان حذف دستگاه‌های خاص نیست",
        "the email is empty": "ایمیل خالی است",
        "the email format is incorrect": "فرمت ایمیل نادرست است",
        "the mobile number is empty": "شماره موبایل خالی است",
        "the mobile number format is incorrect": "فرمت شماره موبایل نادرست است",
        "Site not found": "پروژه پیدا نشد",
        "User not found": "کاربر پیدا نشد",
        "invalid time format": "فرمت زمان نامعتبر است",
        "ground floor type": "نوع طبقه همکف",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "خطا در محدوده شروع طبقه؛ مقادیر مجاز: -۱۰ تا -۱، G0، G1، G2، ۱ تا ۱۲۸.",
        "Building ID must be between 1 and 99.": "شناسه ساختمان باید بین ۱ تا ۹۹ باشد.",
        "Community building name": "نام ساختمان انجمن",
        "Building ID already exists in this community.": "این شناسه ساختمان در انجمن وجود دارد.",
        "building ID": "شناسه ساختمان",
        "Community building not found.": "ساختمان انجمن پیدا نشد.",
        "Cannot delete building because it has associated devices.": "حذف ساختمان ممکن نیست زیرا دستگاه‌های وابسته دارد.",
        "project is not valid": "پروژه نامعتبر است",
        "Cannot delete building because it has associated salto devices.": "حذف ساختمان ممکن نیست زیرا دستگاه‌های سالتو وابسته دارد.",
        "Cannot delete building because it has associated iTec devices.": "حذف ساختمان ممکن نیست زیرا دستگاه‌های iTec وجود دارد.",
        "Cannot delete building because it has associated dormakaba devices.": "حذف ساختمان ممکن نیست زیرا دستگاه‌های dormakaba وابسته دارد.",
        "member limit num": "محدودیت تعداد اعضا",
        "Indoor Monitor No Set Error.": "خطای عدم تنظیم مانیتور داخلی.",
        "The room not has indoor": "اتاق فاقد مانیتور داخلی است.",
        "check user in building error": "بررسی خطای حضور کاربر در ساختمان",
        "The name specified is already in use.": "نام مشخص‌شده قبلاً استفاده شده است.",
        "This timeblock overlaps with an existing one. Please adjust it.": "این بازه زمانی با یک بازه موجود همپوشانی دارد. لطفاً آن را تنظیم کنید.",
        "This door status changed. Please try again.": "وضعیت این در تغییر کرده است. لطفاً دوباره تلاش کنید.",
        "the lock can\'t bind this community": "این قفل نمی‌تواند این جامعه را متصل کند",
        "The custom quantity limit has been exceeded!": "محدودیت تعداد سفارشی تجاوز شده است!",
        "This time span overlaps with an existing one. Please adjust it.": "این بازه زمانی با یک بازه موجود همپوشانی دارد. لطفاً آن را تنظیم کنید.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "زمان اجرای یک‌باره‌ی مورد نظر با زمان اجرای یک‌باره‌ی موجود همپوشانی دارد. لطفاً آن را تنظیم کنید.",
        "Operation Failed. Please try again.": "عملیات ناموفق بود. لطفاً دوباره تلاش کنید.",
        "The image is not a front view.": "تصویر نمای روبرو نیست.",
        "A mask was detected.": "یک ماسک شناسایی شد.",
        "The image resolution is too low.": "وضوح تصویر خیلی پایین است.",
        "No face was detected.": "هیچ چهره‌ای شناسایی نشد.",
        "The file size is too large.": "حجم فایل بیش از حد بزرگ است.",
        "The face in the image is too large.": "صورت در تصویر بیش از حد بزرگ است.",
        "The face in the image is too small.": "صورت موجود در تصویر خیلی کوچک است.",
        "Multiple faces detected.": "چندین چهره شناسایی شد.",
        "The face is not clear enough.": "تصویر صورت به اندازه کافی واضح نیست.",
        "Face detection failed.": "شناسایی چهره ناموفق بود.",
        "Please enter a value between 1 and 9999": "لطفاً مقداری بین ۱ تا ۹۹۹۹ وارد کنید",
        "Please select which input your door sensor is connected to.": "لطفاً انتخاب کنید که سنسور درب شما به کدام ورودی متصل است.",
        "Add temp key failed, please try it again": "افزودن کلید موقت ناموفق بود، لطفاً دوباره تلاش کنید",
        "Dis Not Support Dynamic QRCode Error.": "خطای عدم پشتیبانی از QRCode دینامیک توسط نماینده.",
        "QR code not exist": "کد QR وجود ندارد",
        "The temp key has expired.": "کلید موقت منقضی شده است.",
        "The device is not in the office": "این دستگاه در دفتر نیست",
        "The device is already assigned.": "دستگاه قبلاً اختصاص داده شده است.",
        "The device cannot be assigned to any user.": "این دستگاه نمی‌تواند به هیچ کاربری اختصاص داده شود.",
        "You cannot select an option with fewer users than the current project members.": "شما نمی‌توانید گزینه‌ای را انتخاب کنید که تعداد کاربران آن کمتر از اعضای فعلی پروژه باشد.",
        "File check failed. Please download the latest template and try again.": "بررسی فایل ناموفق بود. لطفاً آخرین قالب را دانلود کرده و دوباره تلاش کنید.",
        "Dynamic QR Code not active.": "کد QR پویا فعال نیست.",
        "Dynamic QR Code not enable.": "کد QR پویا فعال نیست.",
        "{0} not found.": "{0} پیدا نشد.",
        "Tier charge plan": "طرح تعرفه پلکانی",
        "Feature billing charge plan new": "طرح جدید هزینه‌گذاری ویژگی",
        "Feature billing gradient charge plan": "طرح تعرفه‌گذاری پلکانی ویژگی",
        "The exit time cannot be earlier than the entry time.": "زمان خروج نمی‌تواند زودتر از زمان ورود باشد.",
        "User Name or Password": "نام کاربری یا رمز عبور",
        "You can only link up to 5 sites.": "فقط می‌توانید تا ۵ سایت را مرتبط کنید.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "این پلاک خودرو قبلاً برای یک ساکن ثبت شده و نمی‌توان آن را به فهرست مسدود اضافه کرد.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "این پلاک خودرو در لیست سیاه قرار دارد و نمی‌تواند به عنوان وسیله نقلیه ثبت شود.",
        "Elevator not configured in company access floor.": "آسانسور در طبقات دسترسی شرکت پیکربندی نشده است.",
        "the device is not in the office": "این دستگاه در دفتر نیست",
        "A maximum of 1000 data items can be imported": "حداکثر می‌توان ۱۰۰۰ مورد داده وارد کرد",
        "Exit time cannot be later than the current time.": "زمان خروج نمی‌تواند دیرتر از زمان فعلی باشد.",
        "You can only import a file at a time in the current parking lot.": "در پارکینگ فعلی، فقط می‌توانید هر بار یک فایل وارد کنید.",
        "The license plate is already in the blocklist.": "این پلاک قبلاً در فهرست مسدود قرار دارد.",
        "Building name too long.": "نام ساختمان بیش از حد طولانی است.",
        "Unlock failed. Permission denied by user.": "باز کردن قفل ناموفق بود. مجوز توسط کاربر رد شد.",
        "Please remove the sensor device(s) before disabling this feature.": "لطفاً پیش از غیرفعال کردن این قابلیت، دستگاه(های) سنسور را حذف کنید.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "عملیات ناموفق بود! این کاربر از محدودیت روزانه ۱۵ رکورد عبور کرده است.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "در هر پروژه حداکثر {0} دستگاه عمومی می‌توان اضافه کرد. برای افزودن موارد بیشتر، لطفاً با پشتیبانی فنی Akuvox از طریق support{'@'}akuvox.com تماس بگیرید.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "در هر پروژه حداکثر {0} حساب پرسنل می‌توان اضافه کرد. برای افزودن موارد بیشتر، لطفاً با پشتیبانی فنی Akuvox از طریق support{'@'}akuvox.com تماس بگیرید.",
        "cancel": "لغو",


    }
};
